import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';

export class GlobalMessageConfig {
  body: string;
  errors?: string[];
  action?: string;
  type?: 'warn' | 'generic' = 'generic';
  onClose?: () => any;
  onAction?: () => any;
}

@Component({
  selector: 'global-message',
  templateUrl: './global-message.component.html',
  styleUrls: ['./global-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GlobalMessageComponent implements OnInit {
  @HostBinding('style.opacity') opacity = 0;
  @HostBinding('style.transform') transform = `translateY(4rem)`;
  @HostBinding('class.warn') warn = this.data.type === 'warn';

  constructor(public data: GlobalMessageConfig) {}

  ngOnInit() {
    setTimeout(() => {
      this.opacity = 1;
      this.transform = 'translateY(0rem)';
    });
  }

  handleClick(callback: () => any) {
    this.opacity = 0;
    this.transform = `translateY(4rem)`;
    if (callback) setTimeout(() => callback(), 200);
  }
}
